import { useEffect } from 'react';

export interface UseMobileDragModalProps {
    show: boolean;
    handleClose: () => void;
}

export const useMobileDragModal = (props: UseMobileDragModalProps) => {
    const { show, handleClose } = props;

    useEffect(() => {
        if (!show) return;

        const handle = document.getElementById('mobile-drag');
        const modal = document.querySelector('.modal-mobile-bottom') as HTMLElement | null;
        if (!handle || !modal) return;

        let dragging = false;
        let openHeight = modal.getBoundingClientRect().height;

        const onPointerDown = (event: PointerEvent) => {
            dragging = true;
            openHeight = modal.getBoundingClientRect().height;
            handle.setPointerCapture(event.pointerId);
        };

        const onPointerMove = (event: PointerEvent) => {
            if (!dragging) return;
            const newHeight = Math.max(window.innerHeight - event.clientY, 100);
            modal.style.height = `${newHeight}px`;
        };

        const onPointerUp = () => {
            if (!dragging) return;
            dragging = false;

            const modalHeight = modal.getBoundingClientRect().height;
            if (modalHeight < openHeight / 2) {
                handleClose();
            } else {
                modal.style.height = '';
            }
        };

        handle.addEventListener('pointerdown', onPointerDown);
        handle.addEventListener('pointermove', onPointerMove);
        handle.addEventListener('pointerup', onPointerUp);
        handle.addEventListener('pointercancel', onPointerUp);

        return () => {
            handle.removeEventListener('pointerdown', onPointerDown);
            handle.removeEventListener('pointermove', onPointerMove);
            handle.removeEventListener('pointerup', onPointerUp);
            handle.removeEventListener('pointercancel', onPointerUp);
            modal.style.height = '';
        };
    }, [show, handleClose]);
};
